<template lang="pug">
    m-accordion-primary(class="m-accordion-effectiveness-assessment")
        template
            m-accordion-content(v-for="(section, key) in configuration"
                :key="`section-${key}`")
                template(#header="")
                    v-layout(col wrap align-center)
                        v-flex(sm12 class="m-accordion-effectiveness-assessment__box")
                            component(:is="sectionIcons[key]" @click.native.stop="openIconInfoDialog" v-if="sectionIcons[key]" class="m-accordion-effectiveness-assessment__section-icon")
                            | {{section.title}}

                m-list-effectiveness-accordion-questions(
                    :items="questionItems(section.children, key)"
                    :answers="assessment"
                    :section-key="key"
                    @keyup.enter.item="openContentModal($event, key)"
                    @keyup.enter.option-item="openContentModal($event, key)"
                    @click:item="openContentModal($event, key)"
                    @click:option-item="openContentModal($event, key)")
</template>

<script>
    import MAccordionPrimary from "@modules/accordions/types/m-accordion-primary";
    import MAccordionContent from "@modules/accordions/includes/_m-accordion-content";
    import MListEffectivenessAccordionQuestions from "@modules/lists/concrete/m-list-effectiveness-accordion-questions";

    import assessment from "@mixins/helpers/_assessment";
    import {mapActions} from 'vuex';
    import {questions} from "@constants/common";
    import statusIconDialog from "@mixins/additional/_statusIconDialog";

    export default {
        // TODO this functionality will be refactored and rethink after API implementation of effectiveness check
        name: "m-accordion-effectiveness-assessment",
        mixins: [assessment, statusIconDialog],
        components: {
            MListEffectivenessAccordionQuestions,
            MAccordionContent, MAccordionPrimary
        },
        props: {
            configuration: {
                type: Array,
                required: true
            },
            assessment: {
                type: Array,
                required: true
            }
        },
        computed: {
            assessmentList() {
                return this.assessment
            },
            questionsIcons() {
                let result = [];
                this.assessmentList.forEach((sectionAnswers) => {
                    let items = [];
                    sectionAnswers.children.forEach((questionAnswers) => {
                        items.push(this.assessmentHelper.questionIcon(questionAnswers))
                    });
                    result.push(items);
                });
                return result;
            },
            sectionIcons() {
                let result = [];
                this.questionsIcons.forEach((questionsIcons) => {
                    result.push(this.assessmentHelper.sectionIcon(questionsIcons))
                });
                return result;
            }
        },
        methods: {
            ...mapActions({
                'openDialog': 'dialogs/open'
            }),

            openContentModal(payload, sectionKey) {
                const question = payload.item;
                let answer = this.defineAnswerForDialog(payload, sectionKey);
                if (answer) {
                    this.openDialog({
                        type: 'effectivenessQuestion',
                        options: {
                            question: question,
                            answer: answer,
                            sectionTitle: this.configuration[sectionKey].title
                        }
                    })
                }
            },
            defineAnswerForDialog(payload, sectionKey) {
                try {
                    if (payload.item.type === questions.types.option) {
                        let res = this.assessment[sectionKey].children[payload.optionKey].children[0].children[payload.optionSectionKey].children[payload.questionKey];
                        return res;
                    } else {
                        return this.assessment[sectionKey].children[payload.index];
                    }
                } catch (e) {
                    return null;
                }
            },
            questionItems(questionsArray, sectionKey) {
                // TODO this method will be replaced after we will work with api data
                // wee ned to set answer for our options, later this need to remove
                let items = [];
                questionsArray.forEach((item, key) => {
                    items[key] = item;
                    items[key].iconComponnent = this.questionsIcons[sectionKey][key];
                });
                return items;
            }
        }
    }
</script>

<style scoped lang="scss">
    .m-accordion-effectiveness-assessment {

        &__content-item {
            position: relative;
            margin-left: 35px;
            display: inline-block;
            font-weight: normal;
        }

        &__box {
            padding-left: 1.2rem !important;
        }

        &__section-icon {
            margin-right: .5rem;
            margin-bottom: 1px;

            @include updatedMedia(sm) {
                position: unset;
                left: 0px;
                padding-right: 10px;
            }
        }

        &__content-icon {
            position: absolute;
            left: -35px;
            top: -2px;
        }

        /deep/ .v-expansion-panel {
            &__container {
                padding: 1rem;
                -webkit-box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
                box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
                margin-bottom: 1rem;
                border-radius: 3px;
                border-top: none !important;

                &:focus {
                    border-bottom: 2px solid var(--v-primary-base);
                }
            }

            &__header {
                min-height: auto !important;

                .flex {
                    @include updatedMedia(sm) {
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                }
            }

            &__body {

                /deep/ hr {
                    border-top-width: 1px !important;

                    &:first-child,
                    &:last-child {
                        display: none;
                    }
                }
            }
        }
    }

</style>
